import z from 'zod';
import { klarnaAccountSchema } from './KlarnaKosma';
import { LoanType, SignerType } from '~/enums';

const getAddressResDTOSchema = z.strictObject({
  city: z.string(),
  houseNumber: z.number(),
  houseNumberAdditions: z.array(z.string()),
  postcode: z.string(),
  street: z.string(),
});

const getKlarnaKosmaAccountsInfoResDTOSchema = z.strictObject({
  accounts: z.array(klarnaAccountSchema),
  message: z.string(),
});

const getKYCQuestionsAndAnswersResDTOSchema = z.strictObject({
  questions: z.array(
    z.strictObject({
      isactive: z.boolean().optional(),
      answerType: z.number(),
      answers: z.array(
        z.strictObject({
          id: z.number(),
          name: z.string(),
          sequenceNumber: z.number(),
        })
      ),
      id: z.number(),
      name: z.string(),
      notes: z.string().nullable(),
      sequenceNumber: z.number(),
      type: z.strictObject({
        id: z.number(),
        name: z.string(),
        sequenceNumber: z.number(),
      }),
    })
  ),
});

const postKYCAnswersResDTOSchema = z.strictObject({
  answers: z.array(
    z.strictObject({
      answer: z.string(),
      answerId: z.number().nullable(),
      questionId: z.number(),
    })
  ),
});

const postKYCAnswersReqDTOSchema = z.strictObject({
  questionsAndAnswers: z.array(
    z.strictObject({
      answers: z.array(
        z.strictObject({
          answer: z.string(),
          answerId: z.number(),
        })
      ),
      questionId: z.number(),
    })
  ),
});

const getAdditionalSignerLoanApplicationDataResDTOSchema = z.strictObject({
  amount: z.string(),
  bank_account: z.string(),
  company_name: z.string(),
  company_no: z.string(),
  first_name: z.string(),
  landing_url: z.string(),
  language: z.string(),
  last_name: z.string(),
  loan_type: z.nativeEnum(LoanType),
  monthly_fee: z.string(),
  monthly_payment: z.string(),
  payment_due: z.string(),
  personal_id: z.string(),
  signer_type: z.nativeEnum(SignerType),
  term: z.number(),
  granter: z.enum(['qred', 'nordiska']).or(z.literal('')),
});

const getAdditionalSignerCardApplicationDataResDTOSchema = z.strictObject({
  cardApplicationUuid: z.string(),
  companyName: z.string(),
  hasAcceptedPersonalGuarantee: z.boolean(),
  hasAcceptedTerms: z.boolean(),
  interest: z.number(),
  offeredCreditLimit: z.number(),
  signerUuid: z.string(),
});

const postInitiateOTPResDTOSchema = z.strictObject({
  otpExpiryTimestamp: z.number(),
  message: z.string(),
});

const postRegenerateOTPResDTOSchema = z.strictObject({
  otpExpiryTimestamp: z.number(),
  message: z.string(),
});

const postVerifyOTPResDTOSchema = z.strictObject({
  accessToken: z.string().optional(),
  message: z.string(),
  otpExpiryTimestamp: z.number().optional(),
});

const postIdentifyResDTOSchema = z.strictObject({
  identified: z.boolean(),
  redirectUrl: z.string().optional(),
});

export const sharedDTOSchemas = {
  getAddressRes: getAddressResDTOSchema,
  getKlarnaKosmaAccountsInfoRes: getKlarnaKosmaAccountsInfoResDTOSchema,
  getKYCQuestionsAndAnswersRes: getKYCQuestionsAndAnswersResDTOSchema,
  getAdditionalSignerLoanApplicationDataRes: getAdditionalSignerLoanApplicationDataResDTOSchema,
  getAdditionalSignerCardApplicationDataRes: getAdditionalSignerCardApplicationDataResDTOSchema,
  postKYCAnswersReq: postKYCAnswersReqDTOSchema,
  postKYCAnswersRes: postKYCAnswersResDTOSchema,
  postInitiateOTPRes: postInitiateOTPResDTOSchema,
  postRegenerateOTPRes: postRegenerateOTPResDTOSchema,
  postVerifyOTPRes: postVerifyOTPResDTOSchema,
  postIdentifyRes: postIdentifyResDTOSchema,
};

export enum ETokenAuthentication {
  BANK = 'BANK',
  EMAIL = 'EMAIL',
  M2M = 'M2M',
}
